import { useLocation } from "react-router-dom";
import MarketingFooter from "@/components/MarketingFooter";

const Footer = () => {
  const { pathname } = useLocation();

  // App.tsx renders this after <Routes>, so it lands under EVERY page — admin
  // included. The marketing nav already opts out of admin routes
  // (Navigation.tsx), and this is the same gate, kept identical on purpose
  // including the DocuSign exception: that callback is a hand-off page that can
  // flash before redirecting, and it should not appear unbranded.
  const isAdminRoute =
    (pathname === "/admin" || pathname.startsWith("/admin/")) &&
    !pathname.startsWith("/admin/docusign");
  if (isAdminRoute) {
    return null;
  }

  // One footer for the whole site. This used to pick the draft's slim footer
  // for the marketing routes and keep the old sitemap footer everywhere else,
  // so the dashboard, the auth pages and anything missing from the list still
  // wore pre-redesign chrome — a different-looking site one click deep.
  return <MarketingFooter />;
};

export default Footer;
